import React from "react";
import camelcaseKeys from "camelcase-keys";
import { apiResourceUrl } from "@ploy-lib/core";
export class FulfillmentAPI extends React.Component {
    constructor() {
        super(...arguments);
        this.callAPI = async (method, action, params) => {
            const { token } = this.props;
            const noCacheToken = new Date().getTime();
            const response = await fetch(apiResourceUrl(`fulfillment/${action}?${getQueryParams(params)}&t=${noCacheToken}`), {
                method,
                headers: token ? new Headers({ Authorization: token }) : undefined,
                credentials: "include" // Include session cookie
            });
            const data = await response.json();
            return camelcaseKeys(data);
        };
        this.handleGetFulfillment = async (searchParams) => {
            try {
                const response = await this.callAPI("GET", "fulfillment", {
                    ...searchParams
                });
                return response;
            }
            catch (err) {
                throw Error("Error getting fulfillment. " + err.message);
            }
        };
    }
    render() {
        const { children } = this.props;
        return children({
            getFulfillment: this.handleGetFulfillment
        });
    }
}
export const getQueryParams = (params) => {
    return Object.entries(params)
        .map(([k, v]) => encodeURIComponent(k) +
        "=" +
        encodeURIComponent(v instanceof Date ? v.toISOString() : v))
        .join("&");
};
export default FulfillmentAPI;
//# sourceMappingURL=FulfillmentAPI.js.map